module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/chat/chat.component.css
// module id = ./src/app/chat/chat.component.css
// module chunks = main